<p-button (onClick)="showDialog = true">Dodaj jedinicu</p-button>

<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '100vw', height: '100vh'}"
    appendTo="body"
  >
    <h2>Odaberite jedinicu gradiva</h2>
    <app-odaberi-jedinicu (itemSelected)="onSelectedItem($event)"></app-odaberi-jedinicu>
  </p-dialog>
</ng-container>
